<script setup lang="ts">
import { sanitizeGFALAmountInput } from "~/utils/input.utils";

const GFALExStore = useGFALExStore();
const amount = defineModel("amount", { type: String });

function onInput(e: Event) {
  const target = e.target as HTMLInputElement;
  // Allow only digits and one decimal point
  target.value = sanitizeGFALAmountInput(target.value);
  amount.value = target.value;
}

const GFALInputRef = ref<HTMLInputElement | null>(null);

onMounted(() => {
  setTimeout(() => {
    GFALInputRef.value?.focus();
  }, 500);
});
</script>
<template>
  <div>
    <div class="relative mt-2 flex">
      <div class="w-full flex flex-col">
        <input
          ref="GFALInputRef"
          v-model="amount"
          @input="onInput"
          data-test="input-transfer-amount"
          class="px-4 pr-28 w-full h-16 rounded-lg bg-white border border-primary-400 border-r-0 outline-primary-400 focus:ring-1 focus:ring-inset focus:ring-primary-400 focus:border focus:border-primary-400"
          :placeholder="$t('main.modalTransferBegin.enterAmountPlaceholder')"
          maxlength="20"
          autocomplete="off"
          data-1p-ignore
          data-lpignore="true" />
      </div>
      <div
        class="absolute h-16 right-0 justify-between shrink-0 inline-flex gap-2 items-center px-4 text-sm font-medium text-center rounded-r-lg border border-l-0 border-primary-400 outline-primary-400 focus:ring-1 focus:ring-inset focus:ring-primary-400 focus:border focus:border-primary-400 focus:border-l-0">
        <BaseIcon
          name="GFAL_token_black_over_white"
          class="w-7"
          :alt="$t('main.imageAltTexts.GFALTokenLogo')" />
      </div>
    </div>
    <p class="text-sm text-neutral-300 mt-2 flex">
      ~
      {{ GFALExStore.convertToUSD(amount || "0") }}
      USD
    </p>
  </div>
</template>

<style scoped>
html,
body {
  -webkit-overflow-scrolling: touch !important;
  overflow: auto !important;
}
</style>
